import { useCountUp } from '../hooks/useCountUp';

/**
 * Muestra un número animado (0 → value). Por defecto redondea a entero;
 * pásale `format` para moneda u otro formateo (recibe el valor en curso).
 */
export default function CountUp({
  value,
  duration,
  format,
  className,
}: {
  value: number;
  duration?: number;
  format?: (n: number) => string;
  className?: string;
}) {
  const n = useCountUp(value, duration);
  const text = format ? format(n) : Math.round(n).toLocaleString('es-MX');
  return <span className={className}>{text}</span>;
}
